<p-toast></p-toast>
<div [formGroup]="headerFooterForm">
    <p>
        Header HTML
    </p>
    <textarea formControlName="header" class="header-editor"></textarea>
    <p>
        Footer HTML
    </p>
    <textarea formControlName="footer" class="footer-editor"></textarea>
</div>

<p-button (click)="updateHeaders()" label="Save Header & Footer"></p-button>
<div>
    Upload new Logo
    <p-fileUpload [customUpload]="true" (uploadHandler)="uploadLogo($event.files)" [maxFileSize]="64000"></p-fileUpload>
</div>